module.exports = __webpack_public_path__ + "media/images/athletes/3072-10d08a19e089579da3a3a0f72338c535.png";